import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Pachtrechner } from "./pages/Pachtrechner";
import { Leistungen } from "./pages/Leistungen";
import { UeberUns } from "./pages/UeberUns";
import { AngebotAnfordern } from "./pages/AngebotAnfordern";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";
import { Ratgeber } from "./pages/Ratgeber";
import { RatgeberArticle } from "./pages/RatgeberArticle";
import { NotFound } from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";
import { Seo } from "./components/Seo";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Seo />
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pachtrechner" element={<Pachtrechner />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/ratgeber" element={<Ratgeber />} />
            <Route path="/ratgeber/:slug" element={<RatgeberArticle />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/angebot-anfordern" element={<AngebotAnfordern />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<PlaceholderPage title="AGB" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

const PlaceholderPage = ({ title }) => (
  <div className="min-h-screen bg-slate-50 py-20 md:py-28">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#122A5C] mb-8">
        {title}
      </h1>
      <div className="prose max-w-none">
        <p className="text-slate-600">
          Diese Seite wird noch erstellt. Bitte kontaktieren Sie uns für weitere Informationen.
        </p>
      </div>
    </div>
  </div>
);

export default App;
